import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { Currency, CurrencyProps } from 'models/reusable-parts/currency';
import {
  FinancialMarkersRow,
  FinancialMarkersRowProps,
} from './financial-markers-row';

export interface FinancialMarkersProps {
  totalIncome?: CurrencyProps;
  rows: FinancialMarkersRowProps[];
  status: LoadingState;
}

export const FinancialMarkers = types
  .model({
    totalIncome: types.maybe(Currency),
    rows: types.optional(types.array(FinancialMarkersRow), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: FinancialMarkersProps): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        ...props,
      };
      applySnapshot(self, newSnapshot);
    },
    updateStatus(status: LoadingState): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        status,
      };
      applySnapshot(self, newSnapshot);
    },
  }));

export type FinancialMarkersSnapshot = SnapshotIn<typeof FinancialMarkers>;
export type FinancialMarkersInstance = Instance<typeof FinancialMarkers>;
